import { computed } from 'vue';
import router from "@/router";

const isReportsRoute = computed(() => {
    const { fullPath } = router.currentRoute.value;
    return fullPath.startsWith("/reports");
});

export default isReportsRoute;